/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// any CSS you require will output into a single css file (app.css in this case)

require('../styles/main.scss');

require('./main.js');
require('./plenigo/helper');
require('./plenigo/iframe');
require('./plenigo/existingPayment');
require('./plenigo/payone');
require('./plenigo/stripe');
require('./plenigo/stripeIdeal');
require('./plenigo/history');
require('./plenigo/validateEmail');
require('./plenigo/persistInput');
require('./plenigo/syncForms');
require('./plenigo/toggleBic');
require('./plenigo/sdk');
require('./plenigo/toggleDisabled');
require('./plenigo/amazonPay');
require('./plenigo/toggle');
require('./plenigo/optionalOffers');
require('./plenigo/stripeIdentity');
require('./plenigo/formatPostbox');
require('./plenigo/formatStreetNumber');
require('./plenigo/loginIdentifier');
require('./plenigo/stripeButtons');
require('./plenigo/toggleVisibility');
require('./plenigo/datatransCreditCard');
require('./plenigo/datatransLightbox');
require('./plenigo/googleOneTap');
require('./plenigo/accessebility');
// require('./plenigo/logger');

// Need jQuery? Install it with 'yarn add jquery', then uncomment to require it.
// const jQuery = require('jquery');
